export type CelebrationShardShape = "rect" | "circle" | "triangle" | "star";

export interface CelebrationShardSpec {
  id: string;
  left: number;
  color: string;
  duration: number;
  delay: number;
  driftX: number;
  rotation: number;
  shape: CelebrationShardShape;
  size: number;
}

export interface CelebrationTwinkleSpec {
  id: string;
  top: number;
  left: number;
  duration: number;
  delay: number;
  size: number;
}

type ShardTuple = readonly [
  string,
  number,
  string,
  number,
  number,
  number,
  number,
  CelebrationShardShape,
  number,
];

const SHARD_TUPLES: ReadonlyArray<ShardTuple> = [
  ["s1", 4, "text-viz-1", 18, 0, 6, 540, "rect", 10],
  ["s2", 12, "text-viz-2", 22, 4, -4, 360, "circle", 6],
  ["s3", 19, "text-viz-5", 16, 8, 8, 720, "star", 14],
  ["s4", 27, "text-viz-1", 24, 2, -6, 480, "triangle", 12],
  ["s5", 34, "text-viz-2", 20, 11, 5, 600, "rect", 8],
  ["s6", 42, "text-viz-3", 17, 6, -8, 540, "circle", 7],
  ["s7", 50, "text-viz-1", 23, 1, 4, 420, "star", 12],
  ["s8", 58, "text-viz-2", 19, 9, -5, 600, "rect", 10],
  ["s9", 66, "text-viz-4", 21, 3, 7, 540, "triangle", 11],
  ["s10", 73, "text-viz-1", 18, 13, -4, 480, "circle", 8],
  ["s11", 80, "text-viz-2", 25, 5, 6, 720, "star", 14],
  ["s12", 87, "text-viz-5", 17, 10, -7, 420, "rect", 9],
  ["s13", 93, "text-viz-1", 22, 7, 5, 540, "circle", 6],
  ["s14", 22, "text-viz-3", 26, 14, 9, 600, "star", 10],
  ["s15", 46, "text-viz-2", 19, 16, -3, 540, "triangle", 9],
  ["s16", 62, "text-viz-4", 24, 12, 4, 660, "rect", 11],
];

export const CELEBRATION_SHARDS: ReadonlyArray<CelebrationShardSpec> = SHARD_TUPLES.map(
  ([id, left, color, duration, delay, driftX, rotation, shape, size]) => ({
    id,
    left,
    color,
    duration,
    delay,
    driftX,
    rotation,
    shape,
    size,
  }),
);

export const CELEBRATION_TWINKLES: ReadonlyArray<CelebrationTwinkleSpec> = [
  { id: "t1", top: 8, left: 8, duration: 3.2, delay: 0, size: 6 },
  { id: "t2", top: 22, left: 88, duration: 4.1, delay: 1.2, size: 5 },
  { id: "t3", top: 44, left: 14, duration: 3.6, delay: 0.6, size: 7 },
  { id: "t4", top: 38, left: 72, duration: 3.0, delay: 2.4, size: 5 },
  { id: "t5", top: 64, left: 28, duration: 4.4, delay: 1.8, size: 6 },
  { id: "t6", top: 78, left: 92, duration: 3.4, delay: 0.9, size: 5 },
];
